//import axios from "axios";
import React from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import axios from '../../axios/axiosconf';
import logo from '../../../resources/img/logo-2.png';

function NewPassword() {

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');
    const [feedbackType, setFeedbackType] = useState('invalid-feedback');

    let history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            // Obtener CSRF token primero (sin /api porque Sanctum está en la raíz)
            await axios.get('https://smileweb.com.co/sanctum/csrf-cookie');
            
            // Luego enviar la petición
            const response = await axios.post('/send-pwd-reset-link', {
                email: email
            });
            
            console.log(response);
            setMsg(response.data.message);
            setLoading(false);
            setFeedbackType('valid-feedback visible');

            setTimeout(() => {
                history.push('/');
            }, 4000);
        } catch (err) {
            console.log(err.response?.data?.message || err.message);

            setMsg(err.response?.data?.message || 'Error al enviar el correo');
            setLoading(false);
            setFeedbackType('invalid-feedback visible');
        }
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="card card-outline card-primary login-card-style">
                    <div className="card-header text-center">
                        <img src={logo} style={{width: '150px'}} />
                    </div>
                    <div className="card-body">
                    <p className="login-box-msg">Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña</p>

                    <form onSubmit={handleSubmit} method="post">
                        <div className="input-group mb-3">
                        <input type="email" className="form-control" placeholder="Email" onChange={e => setEmail(e.target.value)} />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                <span className="fas fa-envelope"></span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary btn-block">
                                    Enviar&nbsp;
                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                </button>
                            </div>
                        </div>
                        <div className={feedbackType}>
                        {msg}
                        </div>
                    </form>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default NewPassword;